import { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

const faqPreview = [
  { q: "可乐漫画上的内容可以免费看吗？", a: "可以。可乐漫画的基础漫画推荐与追更指南全部免费开放，让你随时都能配上一杯快乐水，随时开启快乐追更。" },
  { q: "追更榜单多久更新一次？", a: "榜单每周更新，编辑团队会根据人气、口碑和更新热度精选热门漫画，方便你快速找到值得追的快乐水组合。" },
  { q: "肥宅快乐套餐是什么？", a: "这是可乐漫画推出的追更搭配灵感，把漫画与快乐水、零食组合成专属套餐，让你在放松摸鱼时一次看个够。" },
  { q: "我在手机上也能正常浏览吗？", a: "当然可以。可乐漫画针对电脑、平板和手机都做了适配，随时随地都能打开快乐水追更之旅。" },
];

export default function Home() {
  const [openFaq, setOpenFaq] = useState<number>(0);

  const heroStats = [
    { value: "128+", label: "热门追更作品" },
    { value: "50w+", label: "快乐读者" },
    { value: "5", label: "大主题分类" },
  ];

  return (
    <Layout>
      <title>可乐漫画 - 配可乐看漫画，肥宅快乐套餐一站式搞定</title>
      <meta name="description" content="可乐漫画配可乐与可乐漫画肥宅快乐套餐，一站搞定。配可乐看漫画的快乐，来可乐漫画就对了。这里有可乐漫画配可乐、肥宅快乐套餐，追更配零食，周末放松摸鱼必备，快乐水组合让你一次看个够。" />
      <meta name="keywords" content="可乐漫画,配可乐,快乐水组合,肥宅快乐套餐,追更配零食,周末放松,摸鱼必备" />
      <link rel="canonical" href="https://snackview.github.io/" />
      <meta property="og:title" content="可乐漫画 - 配可乐看漫画，肥宅快乐套餐一站式搞定" />
      <meta property="og:description" content="配可乐看漫画的快乐，来可乐漫画就对了。追更配零食，周末放松摸鱼必备。" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "可乐漫画",
          description: "配可乐看漫画，肥宅快乐套餐一站式搞定",
          url: "https://snackview.github.io/",
        })}
      </script>

      {/* Hero */}
      <section className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden md:min-h-[620px]">
        <img
          src="https://readdy.ai/api/search-image?query=A%20fun%20and%20playful%20illustrated%20scene%20of%20manga%20books%20and%20cola%20bottles%20with%20rising%20bubbles%20and%20snacks%20floating%20playfully%2C%20warm%20cream%20background%20with%20caramel%20orange%20and%20red%20accents%2C%20stylized%20flat%20cartoon%20artwork%2C%20energetic%20and%20cheerful%20composition%20with%20soft%20warm%20lighting&width=1600&height=900&seq=home-hero&orientation=landscape"
          alt="可乐漫画配可乐与快乐水组合的轻松氛围插画"
          title="可乐漫画 快乐水组合"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/20 to-foreground-950/40" />
        <div className="relative z-10 mx-auto w-full max-w-3xl px-4 py-20 text-center md:px-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/90 px-4 py-1.5 text-sm font-medium text-primary-700 backdrop-blur">
            <i className="ri-cup-fill" style={{ width: 16, height: 16 }} />
            快乐水组合 · 追更配零食
          </span>
          <h1 className="mt-6 font-heading text-3xl leading-snug text-background-50 md:text-5xl">
            配可乐看漫画，
            <br className="hidden md:block" />
            快乐水套餐一站搞定
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
            这里有可乐漫画配可乐、肥宅快乐套餐，追更配零食，周末放松摸鱼必备。打开一本漫画、拧开一罐快乐水，
            让忙碌的一天在气泡里慢慢放松下来。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#trending"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 sm:w-auto"
            >
              开始快乐追更
              <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
            </a>
            <Link
              to="/list"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-background-50/95 px-7 py-3 text-sm font-medium text-primary-700 whitespace-nowrap transition-colors hover:bg-background-100 sm:w-auto"
            >
              查看追更榜单
            </Link>
          </div>
          <div className="mt-12 grid grid-cols-3 gap-4">
            {heroStats.map((s) => (
              <div key={s.label} className="rounded-lg bg-background-50/90 px-2 py-4 text-center backdrop-blur">
                <div className="font-heading text-xl text-primary-700 md:text-2xl">{s.value}</div>
                <div className="mt-1 text-xs text-foreground-700">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 核心玩法 */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-medium text-accent-600">快乐水组合玩法</span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">看漫画的快乐，这样才完整</h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">四种放松姿势，总有一种属于你的快乐水时刻。</p>
        </div>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {[
            { icon: "ri-cup-line", title: "可乐漫画配可乐", desc: "经典快乐水组合，漫画与气泡一起升腾，追更更有滋味。" },
            { icon: "ri-stack-fill", title: "肥宅快乐套餐", desc: "漫画、快乐水、零食一站式搭配，怎么舒服怎么来。" },
            { icon: "ri-restaurant-line", title: "追更配零食", desc: "一口快乐水一口零食，看到精彩处也不怕饿肚子。" },
            { icon: "ri-sofa-line", title: "周末放松摸鱼", desc: "窝进沙发里，让故事带走一周的疲惫，慢慢放松。" },
          ].map((f) => (
            <div
              key={f.title}
              className="group rounded-lg border border-background-200 bg-background-100 p-6 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-transform group-hover:scale-110">
                <i className={`${f.icon} text-xl`} style={{ width: 20, height: 20 }} />
              </span>
              <h3 className="mt-4 text-base font-medium text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 热门追更 */}
      <section id="trending" className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
            <div>
              <span className="text-sm font-medium text-accent-600">本周热门</span>
              <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">追更榜单精选</h2>
              <p className="mt-2 text-sm text-foreground-600">编辑部每周精选，配快乐水一口气看完的热门漫画。</p>
            </div>
            <Link
              to="/list"
              className="inline-flex items-center gap-1.5 rounded-full border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-700 whitespace-nowrap transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              全部追更
              <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
            </Link>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {comics.slice(0, 4).map((c, i) => (
              <ComicCard key={c.id} comic={c} rank={i + 1} />
            ))}
          </div>
        </div>
      </section>

      {/* 主题分类 */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-medium text-accent-600">主题分类</span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">总有一类，配得上你的快乐水</h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">热血、搞笑、日常、治愈、悬疑，选一个开始吧。</p>
        </div>
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group relative flex h-56 flex-col justify-end overflow-hidden rounded-lg border border-background-200"
            >
              <img
                src={c.cover}
                alt={`${c.name} 分类封面`}
                title={`${c.name} 快乐水追更`}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 to-transparent" />
              <div className="relative p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50/20 text-background-50 backdrop-blur">
                  <i className={c.icon} style={{ width: 18, height: 18 }} />
                </span>
                <h3 className="mt-2 font-heading text-lg text-background-50">{c.name}</h3>
                <p className="mt-1 text-xs text-background-200">{c.tagline}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* 追更指南 */}
      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
            <div>
              <span className="text-sm font-medium text-accent-600">追更指南</span>
              <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">快乐追更，也要有章法</h2>
              <p className="mt-2 text-sm text-foreground-600">关于快乐水、零食与漫画的搭配灵感，都在这里。</p>
            </div>
            <Link
              to="/article/1"
              className="inline-flex items-center gap-1.5 rounded-full border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-700 whitespace-nowrap transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              更多指南
              <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
            </Link>
          </div>
          <div className="mt-8 grid gap-5 md:grid-cols-3">
            {articles.slice(0, 3).map((a) => (
              <Link
                key={a.id}
                to={`/article/${a.id}`}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
              >
                <div className="aspect-[16/9] w-full overflow-hidden">
                  <img
                    src={a.cover}
                    alt={a.title}
                    title={`${a.title} 追更配零食`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <span className="text-xs font-medium text-accent-600">{a.category}</span>
                  <h3 className="mt-1.5 line-clamp-2 text-base font-medium text-foreground-950">{a.title}</h3>
                  <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{a.excerpt}</p>
                  <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                    <span>{a.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line" style={{ width: 13, height: 13 }} />
                      {a.readTime}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* 口碑 */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-medium text-accent-600">快乐读者说</span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">一杯快乐水，一群同好</h2>
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {[
            { name: "阿宅小新", role: "每周追更 12 部", text: "可乐漫画配可乐真的太对味了，周末窝在沙发里一边看一边喝，一周的疲惫都没了。" },
            { name: "摸鱼选手", role: "午休快乐看", text: "快乐水组合让我每天午休都有盼头，追更配零食，摸鱼也摸得理直气壮。" },
            { name: "汽水少年", role: "榜单死忠粉", text: "追更榜单更新很及时，肥宅快乐套餐给了我不少搭配灵感，已经爱上这种放松方式。" },
          ].map((t) => (
            <figure key={t.name} className="rounded-lg border border-background-200 bg-background-100 p-6">
              <i className="ri-double-quotes-l text-2xl text-primary-300" style={{ width: 24, height: 24 }} />
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-800">{t.text}</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm text-background-50">
                  {t.name.slice(0, 1)}
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-950">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* FAQ 预览 */}
      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-4xl px-4 md:px-6">
          <div className="mx-auto max-w-2xl text-center">
            <span className="text-sm font-medium text-accent-600">常见问题</span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">关于快乐追更的那些事</h2>
          </div>
          <div className="mt-8 space-y-3">
            {faqPreview.map((f, i) => (
              <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenFaq(openFaq === i ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-950 md:text-base">{f.q}</span>
                  <i
                    className={`text-lg text-primary-600 transition-transform ${openFaq === i ? "rotate-45" : ""}`}
                    style={{ width: 20, height: 20 }}
                  >
                  </i>
                </button>
                {openFaq === i && <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>}
              </div>
            ))}
          </div>
          <div className="mt-6 text-center">
            <Link
              to="/faq"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-600"
            >
              查看全部常见问题
              <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="relative overflow-hidden rounded-2xl bg-primary-500 px-6 py-12 text-center md:px-12 md:py-16">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20warm%20orange%20and%20cream%20colored%20bubbles%20and%20splashes%20floating%20playfully%2C%20soft%20rounded%20shapes%2C%20energetic%20and%20cheerful%20background%20texture%2C%20flat%20cartoon%20style&width=1600&height=600&seq=home-cta&orientation=landscape"
              alt=""
              className="h-full w-full object-cover"
            />
          </div>
          <div className="relative">
            <h2 className="font-heading text-2xl text-background-50 md:text-4xl">快乐水已备好，就差你了</h2>
            <p className="mx-auto mt-3 max-w-xl text-sm text-background-100 md:text-base">
              拧开一瓶快乐水，翻开一本漫画，把周末放松和追更配零食的快乐一次性拉满。
            </p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/list"
                className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-background-50 px-7 py-3 text-sm font-medium text-primary-700 whitespace-nowrap transition-colors hover:bg-background-100 sm:w-auto"
              >
                去看看追更榜单
              </Link>
              <Link
                to="/contact"
                className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-background-50/60 px-7 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-background-50/10 sm:w-auto"
              >
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}